import React from 'react';

const Update = ({service}) => (
    <a href="javascript:;" className="editor" onClick={() => {
        service.batchUpdate();
    }}><i className="fa fa-file-text-o" aria-hidden="true"></i> 修 改</a>
);

export default Update;